import React from 'react';

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Mentions Légales</h1>
        
        <div className="space-y-8 bg-white p-6 rounded-lg shadow">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Éditeur du site</h2>
            <p className="text-gray-600">
              Ce site est édité par Créagency'M<br />
              Adresse : 2 avenue des Oiseaux<br />
              83210 Solliès-Pont, Var<br />
              Email : contact@creagencym.fr<br />
              SIRET : 752 200 220 00024
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">2. Hébergement</h2>
            <p className="text-gray-600">
              Ce site est hébergé par Netlify, Inc.<br />
              610 22nd Street, Suite 315<br />
              San Francisco, CA 94107<br />
              États-Unis<br />
              Site web : https://www.netlify.com
            </p>
            <p className="text-gray-600 mt-4">
              La base de données est hébergée par Firebase (Google LLC)<br />
              1600 Amphitheatre Parkway<br />
              Mountain View, CA 94043<br />
              États-Unis
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Propriété intellectuelle</h2>
            <p className="text-gray-600">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Protection des données personnelles</h2>
            <div className="space-y-4">
              <p className="text-gray-600">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité des données vous concernant. Pour exercer ce droit, vous pouvez nous contacter à l'adresse : contact@creagencym.fr
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-6 mb-2">Finalité du traitement des données</h3>
              <p className="text-gray-600">
                Les données personnelles collectées sur notre application sont utilisées exclusivement pour :
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>La création et la gestion de votre carte de visite numérique</li>
                <li>L'amélioration de nos services et de votre expérience utilisateur</li>
                <li>L'envoi d'informations relatives à nos services et mises à jour</li>
                <li>La personnalisation de nos communications marketing concernant nos propres services</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-6 mb-2">Engagement de confidentialité</h3>
              <p className="text-gray-600">
                Nous nous engageons formellement à ne pas vendre, louer, céder ou donner accès à vos données à des tiers, sauf :
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>En cas d'obligation légale</li>
                <li>En cas de décision de justice</li>
                <li>Pour la défense de nos droits</li>
                <li>Avec votre consentement explicite préalable</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 mt-6 mb-2">Conservation des données</h3>
              <p className="text-gray-600">
                Vos données personnelles sont conservées pendant toute la durée de votre utilisation active du service, et jusqu'à 12 mois après votre dernière connexion. Au-delà de cette période, elles sont soit supprimées, soit anonymisées à des fins statistiques.
              </p>

              <h3 className="text-lg font-medium text-gray-800 mt-6 mb-2">Sécurité des données</h3>
              <p className="text-gray-600">
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires pour assurer la sécurité et la confidentialité de vos données personnelles, notamment pour empêcher leur endommagement, effacement ou accès par des tiers non autorisés.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Cookies</h2>
            <p className="text-gray-600">
              Ce site utilise des cookies nécessaires à son bon fonctionnement. En continuant à naviguer sur ce site, vous acceptez leur utilisation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Limitation de responsabilité</h2>
            <p className="text-gray-600">
              Créagency'M s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu. Toutefois, Créagency'M ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
